import { useState, useEffect } from 'react';
import { LinearProgress, Box } from '@mui/material';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from 'src/@/components/ui/dialog';
import { Textarea } from 'src/@/components/ui/textarea';
import { Label } from 'src/@/components/ui/label';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { Button } from 'src/@/components/ui/button';

export default function ModalBloquearChat({
  open,
  onClose,
  onConfirm,
  loading,
  mode = 'block', // 'block' | 'unblock'
  canal,
  numeroCliente,
}) {
  const [motivo, setMotivo] = useState('');

  useEffect(() => {
    if (!open) setMotivo('');
  }, [open]);

  const isBlock = mode === 'block';
  const title = isBlock ? 'Bloquear contato?' : 'Desbloquear contato?';
  const description = isBlock
    ? `Este número não poderá mais enviar mensagens pelo canal ${canal === 'whatsapp_business' ? 'WhatsApp Business' : 'WhatsApp'}.`
    : `O número voltará a poder enviar mensagens pelo canal ${canal === 'whatsapp_business' ? 'WhatsApp Business' : 'WhatsApp'}.`;

  const handleConfirm = () => {
    onConfirm(isBlock ? { motivo: motivo?.trim() || undefined } : {});
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}>
      <DialogContent className="sm:max-w-[460px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-3 py-2">
          <p className="text-sm text-gray-600">{description}</p>
          {numeroCliente && (
            <p className="text-xs text-gray-500">
              Número: <span className="font-mono">{numeroCliente}</span>
            </p>
          )}

          {isBlock && (
            <div className="flex flex-col gap-1.5 mt-2">
              <Label className="text-xs font-semibold uppercase tracking-wider text-gray-500">
                Motivo (opcional)
              </Label>
              <Textarea
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
                placeholder="Ex.: spam, abuso, etc."
                rows={3}
                className="border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl"
              />
            </div>
          )}

          {loading && (
            <Box sx={{ width: '100%', mt: 1 }}>
              <LinearProgress />
            </Box>
          )}
        </div>

        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <ButtonLoading
            onClick={handleConfirm}
            loading={loading}
            className={isBlock
              ? 'bg-red-600 hover:bg-red-700 text-white'
              : 'bg-[#7C3AED] hover:bg-[#6d28d9] text-white'}
          >
            {isBlock ? 'Bloquear' : 'Desbloquear'}
          </ButtonLoading>
        </div>
      </DialogContent>
    </Dialog>
  );
}
